import { render, staticRenderFns } from "./taskContent.vue?vue&type=template&id=77215049&scoped=true"
import script from "./taskContent.vue?vue&type=script&lang=js"
export * from "./taskContent.vue?vue&type=script&lang=js"
import style0 from "./taskContent.vue?vue&type=style&index=0&id=77215049&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77215049",
  null
  
)

export default component.exports